'use client';

import { cn } from '~/lib/utils';
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from './ui/collapsible';
import { useSearchParams } from 'next/navigation';

type DataDebuggerProps = {
  name?: string;
  data: unknown;
  classname?: string;
  defaultOpen?: boolean;
};

export function DataDebugger({
  name = '',
  data,
  classname,
  defaultOpen = false,
}: DataDebuggerProps) {
  const params = useSearchParams();

  const show = params.has('debug');

  if (!show) {
    return null;
  }

  return (
    <>
      <Collapsible
        defaultOpen={defaultOpen}
        className={cn(
          'data-debugger relative rounded-xl border border-green-600 bg-neutral-50 text-sm text-green-600',
          classname,
        )}
      >
        <CollapsibleTrigger
          disabled={!data}
          className={cn(
            'block w-full rounded-xl p-2 outline-none transition duration-300 hover:bg-[#00000005] focus:ring-2 focus:ring-green-600',
            {
              'text-red-500': !data,
            },
          )}
        >
          {data ? `View ${name && `'${name}'`} data...` : 'No data'}
        </CollapsibleTrigger>
        <CollapsibleContent className="overflow-x-auto px-8 py-4" asChild>
          <pre>
            {JSON.stringify(data, null, 2)}
            <div className="dot-mask pointer-events-none" />
          </pre>
        </CollapsibleContent>
      </Collapsible>
    </>
  );
}
